<template>
    <div id="app">
        <div class="container-fluid p-0 p-lg-3">
            <TheHeader/>
            <div class="body-content">
                <AppLoadingContainer :predicate="!hasAccessToken">
                    <div class="row">

                        <div class="col-xl-2 col-lg-3 col-lg-2 col-md-4">
                            <TheVerticalNavigation/>
                        </div>

                        <div class="col-xl-10 col-lg-9 col-md-8">
                            <RouterView/>
                        </div>

                    </div>
                </AppLoadingContainer>
            </div>

            <TheFooter/>
        </div>
    </div>
</template>

<script>
    import TheHeader from "@/components/layout/TheHeader";
    import TheFooter from "@/components/layout/TheFooter";
    import TheVerticalNavigation from "@/components/layout/TheVerticalNavigation";
    import AppLoadingContainer from "@/components/shared/AppLoadingContainer";
    import AuthenticationService from "@/services/AuthenticationService";

    export default {
        name: 'App',
        components: {
            AppLoadingContainer,
            TheVerticalNavigation,
            TheHeader,
            TheFooter,
        },
        computed: {
            hasAccessToken() {
                return !this.$store.getters.user ? false : this.$store.getters.user.accessToken !== null;
            },
        },
        mounted() {
            AuthenticationService.login();
        }
    }
</script>
